import NoResults from '@/assets/icons/NoResults';

import style from './SearchStatus.module.css';

export default function NothingToShow() {
  return (
    <div className={style.nothingToShow}>
      <NoResults height='150px' width='150px' data-testid='no-results' />
      <p>Er zijn nog geen werklijnen om weer te geven</p>
      <small>Zoek naar materiaal om werklijnen weer te geven</small>
    </div>
  );
}
